export default {
  root: {
    borderRadius: 0,
    boxShadow: 'none!important',
  },
  grouped: {
    borderRight: 'none!important',
  },
};
